export const delay =
  (time: number) =>
  (result: void | PromiseLike<void>): Promise<unknown> =>
    new Promise((resolve) => setTimeout(() => resolve(result), time));
